import * as Yup from 'yup';

export default Yup.object().shape({
  clientId: Yup.string().required('Este campo es requerido')
});
